import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import util from '../../lib/util';

@observer
class Input extends Component {
    render() {
        const {
            handleKeydown = () => {},
            onInput = () => {},

            isValid,
            isCheckbox,
            id,
            name,
            type,
            placeholder = '',
            readonly,
            required,
            value,
            values,
            checked,
            help,
            className = '',
            hideHelp = false,
            dataParams,
            object,
        } = this.props;

        if (type === 'radio' && Array.isArray(values)) {
            return (
                <div>
                    {values.map(obj => (
                        <div class={`form-check ${isValid ? 'is-valid' : ''}`}>
                            <input class={`form-check-input ${isValid ? 'is-valid' : ''} ${className}`}
                                id={`input${name}-${id}`}
                                name={name}
                                type={type}
                                placeholder={placeholder}
                                readonly={readonly}
                                required={required}
                                value={obj.val}
                                onInput={readonly ? () => {} : onInput}
                                checked={obj.val == value ? 'checked' : ''}
                                data-params={dataParams}
                            />
                            <label class='form-check-label' for={`input${name}-${obj.val}`}>
                                {obj.key}
                            </label>
                        </div>
                    ))}
                    {isValid ? <div class={`valid-feedback`} style='display: block;'>
                        Looks good. Saving...
                    </div> : !hideHelp && <small id={`${name}-${id}Help`} class={`form-text text-muted`}>
                        <small class='float-right text-info ml-2'>"{util.getType(value)}"</small>
                        <small class='float-right'>"{name}"</small>
                        {help}
                    </small>}
                </div>
            );
        }

        return (
            <div>
                {/* isCheckbox:{JSON.stringify(isCheckbox)}<br />
                type:{JSON.stringify(type)}<br />
                value type:{typeof value}<br /> */}

                <input class={`${isCheckbox ? 'form-check-input mx-1' : 'form-control'} ${isValid ? 'is-valid' : ''} ${className}`}
                    id={`input${name}-${id}`}
                    name={name}
                    type={type}
                    placeholder={placeholder}
                    readonly={readonly}
                    required={required}
                    value={value}
                    onInput={readonly ? () => {} : onInput}
                    onKeyDown={handleKeydown}
                    checked={checked}
                    data-params={dataParams}
                />
                {isValid ? <div class={`${isCheckbox ? 'ml-4' : ''} valid-feedback`} style='display: block;'>
                    Looks good. Saving...
                </div> : !hideHelp && <small id={`${name}-${id}Help`} class={`${isCheckbox ? 'ml-4' : ''} form-text text-muted`}>
                    <small class='float-right text-info ml-2'>"{util.getType(value)}"</small>
                    <small class='float-right'>"{name}"</small>
                    {util.asString(object, 'updatedFields', name) && <div>
                        <small class='text-primary mr-2'>
                            <span class=''>Last updated: {util.isoDate(util.asString(object, 'updatedFields', name))}</span>
                            {util.asString(object, 'updatedLastValue', name) && <span class='ml-2'>Last value: {util.asString(object, 'updatedLastValue', name)}</span>}
                        </small>
                    </div>}
                    {help}
                </small>}
            </div>
        );
    }
}

export default Input;



// WEBPACK FOOTER //
// ./components/form/input.js